import { AccountRowDataGrid, ColumnIndexes, ColumnKeys } from '../../../accounts/accountsGrid/types';
import { ColumnDetails } from '../../../grid/types/common';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType, UNAVAILABLE_DATA } from '../../types';
import { relatedFindingsRenderer } from '../../utils/utils';
import { htmlDecode } from '../../../utils/escape.utils';

export function companyRenderer(
  rowData: AccountRowDataGrid,
  columnDetails: ColumnDetails<ColumnIndexes, ColumnKeys>
): HTMLElement {
  const company = rowData.item[columnDetails.key];
  let displayString = translateFn('N/A');
  if (company && company.name) {
    displayString = company.name;
  }

  const companyCell: HTMLElement = document.createElement('div');
  companyCell.innerText = htmlDecode(displayString);
  companyCell.className = 'cell-label';

  return companyCell;
}

export function isVulnerableRenderer(rowData: any): HTMLElement {
  const yesNoCell: HTMLElement = document.createElement('div');
  const yesNoString: string = rowData.item.isVulnerable ? translateFn('Yes') : translateFn('No');
  yesNoCell.innerText = this.dependencies.translateFn(yesNoString);
  yesNoCell.className = 'cell-label';

  return yesNoCell;
}

export function artifactNameRenderer(rowData: any): HTMLElement {
  const artifactNameCell: HTMLElement = document.createElement('div');

  artifactNameCell.innerText = htmlDecode(rowData.item.name);
  artifactNameCell.style.color = 'var(--blue-layout-400-primary)';
  artifactNameCell.className = 'cell-label';

  return artifactNameCell;
}

export function artifactCVEsRenderer(rowData: any): HTMLElement {
  const artifactCVEsCell: HTMLElement = document.createElement('div');

  if (!rowData.item.cves || rowData.item.cves.length === 0) {
    artifactCVEsCell.innerText = UNAVAILABLE_DATA;
  } else if (rowData.item.cves?.length === 1) {
    artifactCVEsCell.innerText = rowData.item.cves[0];
    artifactCVEsCell.style.color = 'var(--blue-layout-400-primary)';
  } else {
    artifactCVEsCell.innerText = rowData.item.cves?.length;
    artifactCVEsCell.style.color = 'var(--blue-layout-400-primary)';
  }

  artifactCVEsCell.className = 'cell-label';

  return artifactCVEsCell;
}

export function portRenderer(rowData: any): HTMLElement {
  const portCell: HTMLElement = document.createElement('div');

  if (rowData.item.port) {
    portCell.innerText = rowData.item.port;
  } else {
    portCell.innerText = UNAVAILABLE_DATA;
  }

  portCell.className = 'cell-label';

  return portCell;
}

export function relatedAssetsRenderer(rowData: any): HTMLElement {
  return relatedFindingsRenderer(rowData, FindingClassType.ARTIFACT, FindingClassType.ASSET);
}
